<template>
	<div>
		<el-table class="qcTable" :data="expertGroupList" v-loading="loading">
			<el-table-column prop="Id" label="工作组编号" min-width="120"></el-table-column>
			<el-table-column prop="Name" label="名称"></el-table-column>
			<el-table-column prop="Type" label="类型">
				<template slot-scope="scope">
					<span v-if="scope.row.Type==1" title="影像">影像</span>
					<span v-else-if="scope.row.Type==2" title="报告">报告</span>
					<span v-else title="影像和报告">影像和报告</span>
				</template>
			</el-table-column>
			<el-table-column prop="CreateDt" min-width="100" :formatter="formattertime" label="创建时间"></el-table-column>

			<el-table-column prop="Enable" label="状态">
				<template slot-scope="scope">
					<span v-show="scope.row.Enable == 1">
						启用
					</span>
					<span v-show="scope.row.Enable == 0">
						禁用
					</span>
				</template>
			</el-table-column>

			<el-table-column prop="" label="操作" width="180">
				<template slot-scope="scope">
					<span class="table-task-btn detail" @click="showClick(scope.row)">编辑</span>
					<span class="table-task-btn delete" @click="delterClick(scope.row)">删除</span>
				</template>

			</el-table-column>


		</el-table>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		computed: {
			...Vuex.mapState('managerUser', ['expertGroupList', 'GetExpertGroups', 'ExpertGroupGuids', 'pages', 'loading'])
		},
		methods: {
			...Vuex.mapMutations('managerUser', ['setSplitScreen', 'setLoading']),
			...Vuex.mapActions('managerUser', ['GetExpertGroup', 'userlist', 'DeleteExpertGroup']),
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}
			},
			//编辑
			showClick(arr) {
				this.GetExpertGroups.expertGroupGuid = arr.ExpertGroupGuid
				this.pages.pageCount = 1000;
				this.userlist('GetExpertGroup');
				this.$router.push('/home/manager/newWorkingTeamDetailsedit')
				//      this.setSplitScreen(1)
			},
			//删除
			delterClick(arr) {
				this.ExpertGroupGuids.ExpertGroupGuid = arr.ExpertGroupGuid;
				this.$confirm('是否确定删除此条信息？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.DeleteExpertGroup();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			}

		}

	}
</script>
